import { connect } from 'react-redux'

import { AccountProfile } from '@components/account/accountSections'

import coordinators from '@coordinators'
import { HandleError } from '@coordinators/composed'
import presenters from '@presenters'
import services from '@services'
import { config } from 'hungry-core2'

const mapStateToProps = (state) => {
  const { account, clientReportingPrograms, dinerProfiles, user, router } =
    state

  const port = router.location.port ? `:${router.location.port}` : ''
  const host =
    config.admin_url + (config.admin_url === 'http://localhost' ? port : '')

  return {
    account,
    clientReportingPrograms,
    currentUser: user,
    dinerProfiles,
    host,
  }
}

const mapDispatchToProps = () => {
  const { AccountService, RestService, UIService } = services
  const {
    EditAccount,
    LoadAccountStats,
    LoadAccountDinerProfiles,
    LoadClientReportingPrograms,
    EditClientReportingProgram,
    EditDinerProfile,
    MarkDefaultDinerProfile,
    MarkDefaultAccountContact,
    MarkDefaultAccountAddress,
    RemoveAccountContact,
    RemoveAccountAddress,
  } = coordinators
  const {
    pResponseEditAccount,
    pResponseEditClientAccounting,
    pResponseAccountStats,
    pResponseDinerProfiles,
  } = presenters.Api

  const editAccount = EditAccount({
    AccountService,
    RestService,
    UIService,
    pResponseEditAccount,
    pResponseEditClientAccounting,
  })
  const loadAccountStats = LoadAccountStats({
    RestService,
    pResponseAccountStats,
  })
  const loadDinerProfiles = LoadAccountDinerProfiles({
    RestService,
    AccountService,
    HandleError,
    pResponseDinerProfiles,
  })
  const loadClientReportingPrograms = LoadClientReportingPrograms({
    RestService,
    AccountService,
    HandleError,
  })
  const editClientReportingProgram = EditClientReportingProgram({
    AccountService,
    UIService,
  })
  const editDinerProfile = EditDinerProfile({
    AccountService,
    UIService,
  })
  const markDefaultDinerProfile = MarkDefaultDinerProfile({
    RestService,
    AccountService,
    HandleError,
    pResponseDinerProfiles,
  })
  const deleteAccountContact = RemoveAccountContact({
    RestService,
    AccountService,
    UIService,
    pResponseEditAccount,
    pResponseEditClientAccounting,
    HandleError,
  })
  const markDefaultAccountContact = MarkDefaultAccountContact({
    RestService,
    AccountService,
    pResponseEditAccount,
    pResponseEditClientAccounting,
    HandleError,
  })
  const deleteAccountAddress = RemoveAccountAddress({
    RestService,
    AccountService,
    UIService,
    pResponseEditAccount,
    pResponseEditClientAccounting,
    HandleError,
  })
  const markDefaultAccountAddress = MarkDefaultAccountAddress({
    RestService,
    AccountService,
    pResponseEditAccount,
    pResponseEditClientAccounting,
    HandleError,
  })

  return {
    editAccount,
    loadAccountStats,
    loadDinerProfiles,
    loadClientReportingPrograms,
    editClientReportingProgram,
    editDinerProfile,
    markDefaultDinerProfile,
    markDefaultAccountContact,
    markDefaultAccountAddress,
    deleteAccountContact,
    deleteAccountAddress,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountProfile)
